import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { MapPinIcon } from "lucide-react";
import { useLocalities } from "../../hooks/useLocalities";

const AddressSection = () => {
  const { register, setValue, watch, getValues } = useFormContext();
  const [initialized, setInitialized] = useState(false);
  
  // Obtener valores iniciales
  const initialLocalityId = getValues('localityId');
  const localityId = watch("localityId");
  const { localities, region, department } = useLocalities(localityId);

  // Efecto para manejar la inicialización de localityId
  useEffect(() => {
    if (!initialized && initialLocalityId !== undefined && initialLocalityId !== null) {
      setValue('localityId', initialLocalityId, { 
        shouldValidate: true,
        shouldDirty: false,
        shouldTouch: false
      });
      setInitialized(true);
    }
  }, [initialLocalityId, initialized, setValue]);

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium flex items-center gap-2">
        <MapPinIcon size={18} />
        Domicilio
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <div className="form-group">
          <Label className="form-label">Calle</Label>
          <Input
            {...register("street")}
            className="form-input"
          />
        </div>
        <div className="form-group">
          <Label className="form-label">Número</Label>
          <Input
            {...register("streetNumber")}
            className="form-input"
          />
        </div>
        <div className="form-group">
          <Label className="form-label">Piso</Label>
          <Input
            {...register("floor")}
            className="form-input"
          />
        </div>
        <div className="form-group">
          <Label className="form-label">Barrio</Label>
          <Input
            {...register("neighborhood")}
            className="form-input"
          />
        </div>
        <div className="form-group">
          <Label className="form-label">Localidad</Label>
          <Select
            value={localityId?.toString()}
            onValueChange={(value) => setValue("localityId", Number(value), {
              shouldValidate: true,
              shouldDirty: true
            })}
            defaultValue={initialLocalityId ? String(initialLocalityId) : undefined}
          >
            <SelectTrigger>
              <SelectValue placeholder="Seleccionar localidad" />
            </SelectTrigger>
            <SelectContent>
              {localities.map((locality) => (
                <SelectItem key={locality.id} value={locality.id.toString()}>
                  {locality.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <div className="form-group">
          <Label className="form-label">Departamento</Label>
          <Input 
            className="form-input bg-gray-100"
            value={department}
            disabled
          />
        </div>
        <div className="form-group">
          <Label className="form-label">Región</Label>
          <Input 
            className="form-input bg-gray-100"
            value={region}
            disabled
          />
        </div>
      </div>
    </div>
  );
};

export default AddressSection;
